import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import VALoanCalculator from "./VALoanCalculator.esm.js";
import { FieldConfig } from "./VALoanCalculator.utils.esm.js";
const VALoanCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      homeprice,
      loanProgram,
      interestRate,
      downPayment,
      downPaymentPercent,
      homeInsurance,
      hoa,
      taxRatePercent,
      taxRate,
      includeTaxesInsurance
    } = attrs;
    const defaultValues = {
      homeprice,
      loanProgram,
      interestRate,
      downPayment,
      downPaymentPercent,
      homeInsurance,
      hoa,
      taxRatePercent,
      taxRate,
      includeTaxesInsurance
    };
    return /* @__PURE__ */ jsx(VALoanCalculator, { ...{
      defaultValues
    } }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/va-calculator",
    title: "VA calculator",
    description: "VA home loan calculator to estimate monthly mortgage payment with taxes and insurance.",
    icon: "businessperson",
    keywords: ["mortgages", "calculators", "va", "veterans", "military"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      [FieldConfig.homePrice.name]: {
        type: "number",
        label: "Default home price",
        default: 3e5,
        control: "number"
      },
      [FieldConfig.loanProgram.name]: {
        type: "number",
        label: "Default loan program",
        default: 360,
        control: "select",
        choices: FieldConfig.loanProgram.options
      },
      [FieldConfig.interestRate.name]: {
        type: "number",
        label: "Default interest rate",
        default: 4.176,
        control: "number"
      },
      [FieldConfig.downPayment.name]: {
        type: "number",
        label: "Default down payment",
        default: 6e4,
        control: "number"
      },
      [FieldConfig.downPaymentPercent.name]: {
        type: "number",
        label: "Default down payment percent",
        default: 20,
        control: "number"
      },
      [FieldConfig.homeInsurance.name]: {
        type: "number",
        label: "Default home insurance",
        default: 1260,
        control: "number"
      },
      [FieldConfig.hoa.name]: {
        type: "number",
        label: "Default hoa dues",
        default: 0,
        control: "number"
      },
      [FieldConfig.taxRate.name]: {
        type: "number",
        label: "Default property tax",
        default: 3600,
        control: "number"
      },
      [FieldConfig.taxRatePercent.name]: {
        type: "number",
        label: "Default property tax percent",
        default: 1.2,
        control: "number"
      },
      [FieldConfig.includeTaxesInsurance.name]: {
        type: "boolean",
        default: "true",
        label: "Default include taxes/insurance",
        control: "boolean"
      }
    }
  }
};
export {
  VALoanCalculatorBlock as default
};
